const listPointsBody = document.querySelector('#ads').querySelector('div[name=body]');
// import auth from '../tools/storage.js';

import auth from '../tools/storage.js';

export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index) {
    let status = '';
    if(item.status && item.status === 1)
      status = 'Показы идут';
    else
      status = 'Приостановлена';

    let urlImg = '';
    if(item.image)
      urlImg = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/ads/${item.image}.jpg`;
    else
      urlImg = '';

    return `<div class = "card_ads_preview column p-1 " advID=${item.id}> 
              <img class = "ads_card_preview" style = "max-width:300px;    max-height:120px;    width:auto;    height:auto;"  advID=${item.id}
              src="${urlImg}">
              <div class="row m-0 p-1 w-100"  advID=${item.id}>
                <label  advID=${item.id}>Статус:</label> <div  advID=${item.id} class= "ad_status_active">${status}</div>
              </div>
              <div class="row m-0 p-1 w-100  advID=${item.id}">
                <div class="row m-0 p-1 w-50"  advID=${item.id}>
                  <img class="ad_statistic_icon" src="img/icons8-eye-30.png"  advID=${item.id}>
                  ${item.view}
                </div>
                <div class="row m-0 p-1 w-50"  advID=${item.id}>
                  <img class="ad_statistic_icon" src="img/icons8-open-64.png"  advID=${item.id}>
                  ${item.openLink}
                </div>
              </div>
            </div>`;
    // let urlImg = 'http://festappbuilder.ru/content/festival/1/ads/';
    // let blockFilms = '';
   
    // blockFilms += ' <button id="ads_card_preview" style = "width:200px; height:120px;  padding-left:0px;" type="button" class=" poster_card_preview" data-toggle="modal"> ';
    // blockFilms += '<img class = "ads_card_preview" style = "max-width:200px;    max-height:120px;    width:auto;    height:auto;" src="';
    // blockFilms += `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/ads/${item.ads_img}.jpg`;
    // blockFilms += '_preview.jpg" posterid="';
    // blockFilms += item.ads_id;
    // blockFilms += '"></button>';

    // return blockFilms;

  },

  drawDataInContainer(enterprisesData) {
    let htmlBody = '<div class=" row  p-1">';
    if(enterprisesData)
      enterprisesData.forEach((item, index) => htmlBody += this.getElement(item, index));


    htmlBody +='</div>';
    listPointsBody.innerHTML = htmlBody;
  },

  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
